import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-revolution-slider3',
  templateUrl: './revolution-slider3.component.html'
})
export class RevolutionSlider3Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
